.stack {
  display: inline-flex;
  flex: none;
  align-items: center;
}

/* Each avatar overlaps the one before it; a ring in the surface colour separates them */
.item {
  display: inline-flex;
  border-radius: var(--tuna-shape-radius-circle);
  box-shadow: 0 0 0 2px var(--tuna-palette-background-paper);
}

.item + .item,
.item + .more {
  margin-inline-start: calc(-1.5 * var(--tuna-spacing-0_5));
}

.more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding-inline: var(--tuna-spacing-0_5);
  border-radius: var(--tuna-shape-radius-circle);
  box-shadow: 0 0 0 2px var(--tuna-palette-background-paper);
  background-color: var(--tuna-palette-action-selected);
  color: var(--tuna-content-secondary);
  font-size: var(--tuna-typography-fontSize-xs);
}
